import { ESavedSearchActionTypes } from '../../actions/savedSearches/types';
import { TReduxActions } from '../../types/redux';
import { ISavedSearches } from '../../types/savedSearch';

export const savedSearchesInitialState = {
  count: null,
  isFetching: false,
  searches: null,
};

export const savedSearchesReducer = (
  state: ISavedSearches = savedSearchesInitialState,
  action: TReduxActions,
): ISavedSearches => {
  switch (action.type) {
    case ESavedSearchActionTypes.Set: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ESavedSearchActionTypes.Remove: {
      const {
        payload: { ids },
      } = action;

      const savedSearches = state.searches || [];
      const savedSearchesCount = state.count || 0;

      return {
        ...state,
        count: savedSearchesCount - ids.length,
        searches: savedSearches.filter(search => !ids.includes(search.id as number)),
      };
    }
    case ESavedSearchActionTypes.ChangeFrequency: {
      const {
        payload: { id, frequency, status },
      } = action;

      const savedSearches = state.searches || [];
      const nextSearches = savedSearches.slice();
      const changedIndex = nextSearches.findIndex(search => search.id === id);
      nextSearches[changedIndex] = {
        ...nextSearches[changedIndex],
        frequency,
        selectedFrequency: frequency,
        status,
      };

      return {
        ...state,
        searches: nextSearches,
      };
    }
    case ESavedSearchActionTypes.ChangeTitle: {
      const {
        payload: { id, title },
      } = action;

      const savedSearches = state.searches || [];
      const nextSearches = savedSearches.slice();
      const changedIndex = nextSearches.findIndex(search => search.id === id);
      nextSearches[changedIndex] = {
        ...nextSearches[changedIndex],
        name: title,
      };

      return {
        ...state,
        searches: nextSearches,
      };
    }
    default:
      return state;
  }
};
